import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M16.5 4.5h-2.352l-1.236-3.06A1.504 1.504 0 0 0 11.518.5H6.482c-.613 0-1.164.372-1.394.94L3.852 4.5H1.5C.675 4.5 0 5.175 0 6v10c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6c0-.825-.675-1.5-1.5-1.5zm.3 11.5c0 .163-.137.3-.3.3h-15a.304.304 0 0 1-.3-.3V6c0-.163.137-.3.3-.3h3.161l1.54-3.81a.3.3 0 0 1 .281-.19h5.036a.3.3 0 0 1 .281.19l1.54 3.81H16.5c.163 0 .3.137.3.3v10zM9 5.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zm0 7.8c-1.82 0-3.3-1.48-3.3-3.3S7.18 6.7 9 6.7s3.3 1.48 3.3 3.3-1.48 3.3-3.3 3.3z" />
  </svg>
);

export default SvgComponent;
